import { registerComponent } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "addon-selector",
  class AddonSelector extends WYATTElement {
    #selectedVariant = null;
    constructor() {
      super();
      this.optionSelector = null;
      this.remove = null;
      this.wrapper = null;
      this.activeWrapper = null;
      this.inactiveWrapper = null;
    }

    get selectedVariant() {
      return this.#selectedVariant;
    }

    set selectedVariant(newValue) {
      if (this.#selectedVariant !== newValue) {
        this.#selectedVariant = newValue;
        if (this.#selectedVariant) {
          this.enable();
        } else {
          this.disable();
        }
        this.publish(WYATT.PubSub.events.addonSelectionChanged);
      }
    }

    connectedCallback() {
      const {
        id,
        variantOptions,
        wrapper,
        activeWrapper,
        inactiveWrapper,
        removeSelector,
      } = this.config;

      if (variantOptions && wrapper && activeWrapper && inactiveWrapper) {
        this.optionSelector = document.querySelectorAll(
          `[${variantOptions}="${id}"]`,
        );
        this.wrapper = this.querySelector(wrapper);
        this.activeWrapper = this.querySelector(activeWrapper);
        this.inactiveWrapper = this.querySelector(inactiveWrapper);
        this.optionSelector.forEach((option) => {
          option.addEventListener("change", this.optionChange.bind(this));
        });
      }

      if (removeSelector) {
        this.remove = this.querySelector(removeSelector);
        this.remove.addEventListener("click", this.disableSelection.bind(this));
      }
    }

    optionChange(event) {
      if (event.target.checked) {
        this.selectedVariant = event.target.value;
      }
    }

    enable() {
      const { activeClass, itemSelectorAttr, itemActiveClass } = this.config;
      if (activeClass) {
        this.wrapper.classList.add(activeClass);
      }
      const activeItem = this.querySelector(`.${itemActiveClass}`);
      if (activeItem) {
        activeItem.classList.remove(itemActiveClass);
      }
      const item = this.querySelector(
        `[${itemSelectorAttr}="${this.#selectedVariant}"]`,
      );
      if (item) {
        item.classList.add(itemActiveClass);
      }
    }

    disable() {
      const { activeClass, itemActiveClass } = this.config;
      if (activeClass) {
        this.wrapper.classList.remove(activeClass);
      }
      const item = this.querySelector(`.${itemActiveClass}`);
      if (item) {
        item.classList.remove(itemActiveClass);
      }
      this.optionSelector.forEach((option) => {
        option.checked = false;
      });
    }

    disableSelection() {
      this.selectedVariant = null;
    }
  },
);
